import { render, staticRenderFns } from "./InputSearchOwner.vue?vue&type=template&id=1542b5d2&scoped=true"
import script from "./InputSearchOwner.vue?vue&type=script&lang=js"
export * from "./InputSearchOwner.vue?vue&type=script&lang=js"
import style0 from "./InputSearchOwner.vue?vue&type=style&index=0&id=1542b5d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1542b5d2",
  null
  
)

export default component.exports